module.exports = __webpack_public_path__ + "static/media/mail.85a9fb43.svg";